import { Box, Typography } from '@mui/material';
import React from 'react';
import { Card } from '../Library/Card';
import { colors } from '../../utils/theme';

export const TestRenewelInfoCard = ({
  testType,
}: {
  testType: 'blood' | 'cortisol';
}): JSX.Element => {
  return (
    <Box>
      <Card
        title={`It's time to retake your ${testType} test`}
        icon="alarmClock"
        content={
          <Box display="flex" flexDirection="column" sx={{ mt: 2 }}>
            <Typography sx={{ mb: 1.5 }} fontSize={14} variant="light">
              Your {testType} results are older than{' '}
              {testType === 'blood' ? '1 year' : '3 months'}.
            </Typography>
            <Typography fontSize={14} variant="light">
              In that time, changes in your lifestyle, biology, diet, and more
              may have affected your{' '}
              {testType === 'blood' ? 'blood nutrient and mineral' : testType}{' '}
              levels.
            </Typography>
          </Box>
        }
        cardStyles={{
          background: colors.yellows.HIGHLIGHT,
          color: colors.greys.BRAND_BLACK,
        }}
      />
    </Box>
  );
};
